// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d3889ee0","455":"d6945474","977":"3abf444f"}[chunkId] + ".chunk.js";
};